<template>
    <form
        method="get"
        id="search-form"
        role="search"
        :action="url"
        class="flex w-full items-center border-b border-gray-800 focus-within:border-white pb-4 transition-all duration-300 ease-in-out-quad"
    >
        <input
            ref="searchField"
            @focus="$parent.focused = true"
            @blur="$parent.focused = false"
            @click="$root.$emit('cursorClick')"
            id="s"
            name="s"
            type="text"
            placeholder="Search"
            :value="term ? term : ''"
            class="flex-1 w-full bg-transparent text-gray-150 focus:text-white placeholder-gray-150 focus:placeholder-gray-700 text-3xl lg:text-4xl tracking-tight focus:outline-none pr-6 transition-all duration-300 ease-in-out-quad"
        />

        <!-- :: Search Button
        {+} ---------------------------------- -->
        <button
            @mouseover="manualHover ? $root.$emit('cursorEnter') : ''"
            @mouseleave="manualHover ? $root.$emit('cursorLeave') : ''"
            @click="manualHover ? $root.$emit('cursorClick') : ''"
            id="search-submit"
            type="submit"
            class="flex-shrink-0 w-6 sm:w-8 lg:w-10 text-white hover:text-aqua-500 focus:text-aqua-500 transition-colors duration-300 ease-in-out-quad"
            aria-label="Search Riverwatch"
        >
            <svg class="w-full stroke-current stroke-w-3" viewBox="0 0 46 46">
                <path
                    d="M18 33.5c8.837 0 16-7.163 16-16s-7.163-16-16-16-16 7.163-16 16 7.163 16 16 16zM28.5 28l16 17"
                    fill="none"
                />
            </svg>
        </button>
    </form>
</template>

<script>
export default {
    props: {
        url: String,
        term: String,
        manualHover: Boolean
    }
};
</script>
